module.exports = __webpack_public_path__ + "assets/retina_Angle60DropDetailed.36e0677daa0e9c5df4ff402029abf6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle60DropDetailed.png
// module id = 618
// module chunks = 0